import {Directive, ElementRef, OnInit, Input, forwardRef, EventEmitter} from "@angular/core";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {NormalizerFactory, NormalizerI} from "../normalizers";
import {ModelListener} from "../model-listener";
import {isNil} from "lodash";
import {DATE} from "../../constants";
const $ = require("jquery");
require("bootstrap-datepicker");

const DEFAULT_FORMAT = 'dd.mm.yyyy';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DatePicker),
    multi: true
};

//Directive that adds date-picker to any element
@Directive({
    selector: '[date-picker]',
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class DatePicker extends ModelListener implements OnInit, ControlValueAccessor {

    dateFormat: string;

    onChange: EventEmitter<any> = new EventEmitter<any>();
    onTouchedCallback: EventEmitter<any> = new EventEmitter<any>();

    @Input('date-format') set _dateFormat(format: string) {
        if (!!format) this.dateFormat = format;
        else this.dateFormat = DEFAULT_FORMAT;
    };

    @Input('default-date') defaultDate: Date;
    @Input('start-date') startDate: Date;
    @Input('end-date') endDate: Date;

    private normalizer: NormalizerI;

    constructor(private el: ElementRef) {
        super();

        this.normalizer = NormalizerFactory.getNormalizer(DATE);
    }

    keyFormatter(newKey) {
        return this.normalizer.normalize(newKey);
    }

    valueFormatter(newValue) {
        return this.normalizer.normalize(newValue);
    }

    writeValue(obj, blockEventRaiser: boolean = false) {
        if (!isNil(obj)) {
            super.writeValue(obj);
            let key = this.keyFormatter(obj);
            if (!blockEventRaiser) $(this.el.nativeElement).datepicker('setDate', key);
        } else {
            super.writeValue('');
            if (!blockEventRaiser) $(this.el.nativeElement).datepicker('setDate', '');
        }
    }

    ngOnInit() {
        //todo andrey resolve typescript lazy loading problem
        //lazy loading outer library
        //noinspection TypeScriptValidateTypes,TypeScriptUnresolvedFunction

        //initializing bootstrap-datepicker
        $(this.el.nativeElement).datepicker({
            format: this.dateFormat,
            autoclose: true,
            maxViewMode: 2,
            templates: {
                leftArrow: '<i class="glyphicon glyphicon-chevron-left"></i>',
                rightArrow: '<i class="glyphicon glyphicon-chevron-right"></i>',
            }
        });

        //datepicker change detector
        $(this.el.nativeElement).on('changeDate', (event) => {
            if (this.innerValue != (event.target.value)) {
                this.writeValue(event.target.value, true);
            }
        });

        $(this.el.nativeElement).on('clearDate', () => {
            this.writeValue("", true);
        });

        // Set begin date if exists
        if (this.startDate) {
            $(this.el.nativeElement).datepicker('setStartDate', this.startDate);
        }

        // Set end date if exists
        if (this.endDate) {
            $(this.el.nativeElement).datepicker('setEndDate', this.endDate);
        }
        $(this.el.nativeElement).on("blur", () => {
            this.onTouchedCallback.emit();
        });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/datepicker/datepicker.directive.ts